var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{
          'row':!_vm.info_full_width
        }},[_c('div',{class:{
                'col-8':!_vm.info_full_width,
                'mb-3':_vm.ticketInfoDescriptionShort || _vm.ticketInfoDescriptionLong
             }},[(_vm.ticketInfoDescriptionShort)?[_vm._v("\n                "+_vm._s(_vm.ticketInfoDescriptionShort)+"\n            ")]:_vm._e(),_vm._v(" "),(_vm.ticketInfoDescriptionLong)?_c('div',{class:{
        'newspaper':!_vm.layout_vertical
        },domProps:{"innerHTML":_vm._s(_vm.ticketInfoDescriptionLong)}}):_vm._e()],2),_vm._v(" "),_c('div',{class:{
            'col-4':!_vm.info_full_width
        }},[(_vm.hasImage)?_c('ImageResponsive',{staticClass:"mw-100 d-block mx-auto mb-1",attrs:{"image":_vm.ticketInfoImage,"alt":_vm.ticket.title,"default_size":"md","lazy_load":true}}):_vm._e()],1)]),_vm._v(" "),_c('hr',{staticClass:"d-block d-md-none my-0"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a3909ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/tickets/TicketInfo.vue
// module id = bzIM
// module chunks = 0